import { makeFetch } from './base';
import {
  GET_PROJECT,
  GET_PUBLIC_PROJECT,
  GET_QUESTION_PROPERTY,
  GET_PUBLIC_QUESTION_PROPERTY,
  GET_SURVEY_GROUPS,
  GET_SURVEY_QUESTIONS,
  GET_SURVEY_RESPONSES,
  GET_PUBLIC_SURVEY_GROUPS,
  GET_PUBLIC_SURVEY_QUESTIONS,
  GET_PUBLIC_SURVEY_RESPONSES,
  GET_SURVEY_TIMINGS,
  GET_PUBLIC_SURVEY_TIMINGS,
  GET_SURVEY_VIEW_COUNT,
  GET_QUALTRICS_SURVEY_QUESTIONS,
  GET_QUALTRICS_SURVEY_RESPONSES,
} from '../fetchTypes';

export default (fetchType) => {
  switch (fetchType) {
    case GET_PROJECT:
      return (data) => makeFetch(`projects/${data.projectId}`, 'GET');
    case GET_PUBLIC_PROJECT:
      return (data) => makeFetch(`projects/public/${data.projectId}`, 'GET');
    case GET_SURVEY_QUESTIONS:
      return (data) =>
        makeFetch(
          `projects/${data.projectId}/survey-questions/?factor=${data.factor}`,
          'GET'
        );
    case GET_QUALTRICS_SURVEY_QUESTIONS:
      return (data) =>
        makeFetch(
          `projects/${data.projectId}/qualtrics-questions/?factor=${data.factor}`,
          'GET'
        );
    case GET_SURVEY_GROUPS:
      return (data) =>
        makeFetch(
          `projects/${data.projectId}/survey-groups/?factor=${data.factor}`,
          'GET'
        );
    case GET_PUBLIC_SURVEY_QUESTIONS:
      return (data) =>
        makeFetch(
          `projects/public/${data.projectId}/survey-questions/?factor=${data.factor}`,
          'GET'
        );
    case GET_PUBLIC_SURVEY_GROUPS:
      return (data) =>
        makeFetch(
          `projects/public/${data.projectId}/survey-groups/?factor=${data.factor}`,
          'GET'
        );
    case GET_SURVEY_VIEW_COUNT:
      return (data) =>
        makeFetch(`projects/surveys/${data.sid}/count-view`, 'GET');
    case GET_SURVEY_RESPONSES:
      return (data) =>
        makeFetch(
          `projects/${data.projectId}/survey-responses/?sCompletionStatus=${data.sCompletionStatus}&factor=${data.factor}`,
          'POST'
        );
    case GET_QUALTRICS_SURVEY_RESPONSES:
      return (data) =>
        makeFetch(
          `projects/${data.projectId}/qualtrics-responses/?sCompletionStatus=${data.sCompletionStatus}`,
          'POST'
        );
    case GET_PUBLIC_SURVEY_RESPONSES:
      return (data) =>
        makeFetch(
          `projects/public/${data.projectId}/survey-responses/?sCompletionStatus=${data.sCompletionStatus}&factor=${data.factor}`,
          'POST'
        );
    case GET_QUESTION_PROPERTY:
      return (data) =>
        makeFetch(
          `projects/${data.projectId}/survey-questions/${data.qid}/?factor=${data.factor}`,
          'GET'
        );
    case GET_PUBLIC_QUESTION_PROPERTY:
      return (data) =>
        makeFetch(
          `projects/public/${data.projectId}/survey-questions/${data.qid}/?factor=${data.factor}`,
          'GET'
        );
    case GET_SURVEY_TIMINGS:
      return (data) => {
        const {
          projectId,
          questions,
          surveyFormat,
          savetimings,
          sCompletionStatus,
        } = data;
        const url = `projects/${projectId}/survey-responses/?sCompletionStatus=${sCompletionStatus}`;
        const body = (() => {
          if (!questions || savetimings !== 'Y') return {};
          const aFields = ['id'];
          let gidSet = new Set();
          questions.forEach((q) => {
            if (!gidSet.has(q.gid) && surveyFormat === 'G') {
              // group by group
              aFields.push(`${q.sid}X${q.gid}time`);
              gidSet.add(q.gid);
            }
            if (surveyFormat === 'S') {
              // question by question
              aFields.push(`${q.sid}X${q.gid}X${q.qid}time`);
            }
          });
          return { aFields };
        })();

        if (savetimings !== 'Y') {
          return Promise.resolve({ data: { isSuccess: true } });
        }

        return makeFetch(url, 'POST', body);
      };
    case GET_PUBLIC_SURVEY_TIMINGS:
      return (data) => {
        const {
          projectId,
          questions,
          surveyFormat,
          savetimings,
          sCompletionStatus,
        } = data;
        const url = `projects/public/${projectId}/survey-responses/?sCompletionStatus=${sCompletionStatus}`;
        const body = (() => {
          if (!questions || savetimings !== 'Y') return {};
          const aFields = ['id'];
          let gidSet = new Set();
          questions.forEach((q) => {
            if (!gidSet.has(q.gid) && surveyFormat === 'G') {
              // group by group
              aFields.push(`${q.sid}X${q.gid}time`);
              gidSet.add(q.gid);
            }
            if (surveyFormat === 'S') {
              // question by question
              aFields.push(`${q.sid}X${q.gid}X${q.qid}time`);
            }
          });
          return { aFields };
        })();

        if (savetimings !== 'Y') {
          return Promise.resolve({ data: { isSuccess: true } });
        }

        return makeFetch(url, 'POST', body);
      };
    default:
      return null;
  }
};
